"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_help__at__hand__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "768c1db7-22d9-4f1c-8c14-ffa43166c31a",
    "data-name": "return-product-hi",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "43204dbe-c9e1-4328-91a4-e4798f1b72d3",
    x1: 163.31,
    y1: -95.98,
    x2: 163.31,
    y2: -4.07,
    gradientTransform: "matrix(0.63, -0.63, 0.86, 0.86, 68.93, 246.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "help-at-hand-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "ef6b67e2-526c-4e61-be73-f2312148e814",
    "data-name": "Business_ic_hi 2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    transform: "translate(192 192) rotate(-180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    transform: "translate(192 192) rotate(-180)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9,87.37l-10-30A2,2,0,0,0,164,56H116l0,72h44a16,16,0,0,0,16-16V88A2,2,0,0,0,175.9,87.37Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,40H32A16,16,0,0,0,16,56v56a16,16,0,0,0,16,16h84V56A16,16,0,0,0,100,40Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,88h39.5l-7.09-21.26c-.54-1.63-1.57-2.74-3.29-2.74H128a4,4,0,0,0-4,4V84A4,4,0,0,0,128,88Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128,88h39.5l-7.09-21.26c-.54-1.63-1.57-2.74-3.29-2.74H128a4,4,0,0,0-4,4V84A4,4,0,0,0,128,88Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,96h-4a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4Z",
    transform: "translate(0 0)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,126H116v2h44a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,126Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.14,126H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16h84v-2H34.14Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,108a20,20,0,0,0-20,19.36,16,16,0,0,0,4.47.64H68A20,20,0,0,0,48,108Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,108a20,20,0,0,0-19.5,15.61L116,128h40A20,20,0,0,0,136,108Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,144a16,16,0,1,1,16-16A16,16,0,0,1,48,144Z",
    transform: "translate(0 0)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,128a8,8,0,1,1-8-8A8,8,0,0,1,56,128Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,142a16,16,0,0,1-15.95-15c0,.33-.05.66-.05,1a16,16,0,0,0,32,0c0-.34,0-.67-.05-1A16,16,0,0,1,48,142Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.84,128a16,16,0,0,0,16-16v-3.21L123.55,56H116l0,72Z",
    transform: "translate(0 0)",
    opacity: 0.06,
    fill: "url(#43204dbe-c9e1-4328-91a4-e4798f1b72d3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,144a16,16,0,1,1,16-16A16,16,0,0,1,136,144Z",
    transform: "translate(0 0)",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144,128a8,8,0,1,1-8-8A8,8,0,0,1,144,128Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56,128a8,8,0,1,1-8-8A8,8,0,0,1,56,128Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144,128a8,8,0,1,1-8-8A8,8,0,0,1,144,128Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136,142a16,16,0,0,1-15.95-15c0,.33-.05.66-.05,1a16,16,0,1,0,32,0c0-.34,0-.67-.05-1A16,16,0,0,1,136,142Z",
    transform: "translate(0 0)",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65.96,
    y1: 66,
    x2: 65.96,
    y2: 98,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.96,
    y1: 81.5,
    x2: 49.96,
    y2: 81.5,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.39,44h1.22a4,4,0,0,1,3.95,3.34L148,56H136l1.44-8.66A4,4,0,0,1,141.39,44Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.67 54 148 56 136 56 136.33 54 147.67 54",
    opacity: 0.12
  })));
}

var _default = ic_help__at__hand__dark;
exports.default = _default;